/**
 * Body / main-nav scroll flags.
 * Read scroll position once per frame and write the class only when the threshold changes,
 * so a scroll handler does not query layout after invalidating styles.
 */
(function () {
	var body = document.body;
	var nav = document.querySelector('.main-navigation');
	var bodyScrolled = false;
	var navScrolled = false;
	var scheduled = false;

	function apply() {
		scheduled = false;

		var y = window.scrollY;
		var nextBody = y > 200;
		var nextNav = y > 300;

		if (nextBody !== bodyScrolled) {
			bodyScrolled = nextBody;
			body.classList.toggle('scrolleddown-200', nextBody);
		}

		if (nav && nextNav !== navScrolled) {
			navScrolled = nextNav;
			nav.classList.toggle('scrolled-down', nextNav);
		}
	}

	function requestUpdate() {
		if (scheduled) {
			return;
		}
		scheduled = true;
		window.requestAnimationFrame(apply);
	}

	requestUpdate();
	window.addEventListener('scroll', requestUpdate, { passive: true });
})();

/**
 * CF7 file fields: toggle .has-file on .wpcf7-form-control-wrap when files are chosen or cleared.
 * Uses delegated change (CF7 resets/replaces fields without firing change) + CF7 events to resync.
 */
(function () {
	function updateFileWrapState(input) {
		if (!input || input.type !== 'file') return;
		var wrap = input.closest('.wpcf7-form-control-wrap');
		if (!wrap) return;
		var hasFiles = !!(input.files && input.files.length > 0);
		wrap.classList.toggle('has-file', hasFiles);
	}

	function syncAllFileWrapsIn(root) {
		var scope = root && root.querySelectorAll ? root : document;
		scope.querySelectorAll('.wpcf7-form-control-wrap input[type="file"]').forEach(updateFileWrapState);
	}

	function boot() {
		syncAllFileWrapsIn(document);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	document.addEventListener('change', function (e) {
		var t = e.target;
		if (!t || t.type !== 'file' || !t.closest) return;
		if (!t.closest('.wpcf7-form-control-wrap')) return;
		updateFileWrapState(t);
	});

	function onCf7FormEvent(e) {
		var form = e.target;
		if (form && typeof form.querySelectorAll === 'function') {
			syncAllFileWrapsIn(form);
		} else {
			syncAllFileWrapsIn(document);
		}
	}

	document.addEventListener('wpcf7submit', onCf7FormEvent);
	document.addEventListener('wpcf7reset', onCf7FormEvent);
})();

/**
 * On-page menu: smooth scroll to section anchors.
 */
(function () {
	var menu = document.querySelector('.section.section--onpage-menu');
	if (!menu) {
		return;
	}

	function prefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	menu.addEventListener('click', function (e) {
		var link = e.target.closest('.onpage-menu__link[href^="#"]');
		if (!link || !menu.contains(link)) {
			return;
		}

		var id = (link.getAttribute('href') || '').slice(1);
		if (!id) {
			return;
		}

		var target = document.getElementById(id);
		if (!target) {
			return;
		}

		e.preventDefault();
		target.scrollIntoView({
			behavior: prefersReducedMotion() ? 'auto' : 'smooth',
			block: 'start',
		});
		history.pushState(null, '', '#' + id);
	});
})();

/**
 * Collapse toggles: teasers layout B + price charts "Alle anzeigen".
 */
(function () {
	document.addEventListener('click', function (e) {
		var btn = e.target.closest('.teasers__toggle, .price-charts__toggle');
		if (!btn) {
			return;
		}

		var root = btn.closest('[data-teasers-collapse], [data-price-charts-collapse]');
		if (!root) {
			return;
		}

		var panel = root.querySelector('.teasers__overflow, .price-charts__more-panel');
		root.classList.add('is-expanded');
		btn.setAttribute('aria-expanded', 'true');
		if (panel) {
			panel.setAttribute('aria-hidden', 'false');
		}
	});
})();

/**
 * Admin headline hierarchy helper (footer toggle, logged-in dev user only).
 */
(function () {
	var btn = document.querySelector('.btn-toggle-headline-view');
	if (!btn) {
		return;
	}

	var storageKey = 'didapress-headline-view';

	function setActive(active) {
		document.body.classList.toggle('is-headline-view-active', active);
		btn.setAttribute('aria-pressed', active ? 'true' : 'false');
		try {
			sessionStorage.setItem(storageKey, active ? '1' : '0');
		} catch (e) {}
	}

	try {
		if (sessionStorage.getItem(storageKey) === '1') {
			setActive(true);
		}
	} catch (e) {}

	btn.addEventListener('click', function () {
		setActive(!document.body.classList.contains('is-headline-view-active'));
	});
})();

/**
 * Admin section id helper (footer toggle, logged-in dev user only).
 */
(function () {
	var btn = document.querySelector('.btn-toggle-section-id-view');
	if (!btn) {
		return;
	}

	var storageKey = 'didapress-section-id-view';
	var badgeClass = 'section-id-view-badge';
	var copiedClass = 'is-copied';

	function copyText(text) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(text);
		}

		return new Promise(function (resolve, reject) {
			var textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.setAttribute('readonly', '');
			textarea.style.position = 'absolute';
			textarea.style.left = '-9999px';
			document.body.appendChild(textarea);
			textarea.select();

			try {
				document.execCommand('copy');
				document.body.removeChild(textarea);
				resolve();
			} catch (error) {
				document.body.removeChild(textarea);
				reject(error);
			}
		});
	}

	function removeBadges() {
		document.querySelectorAll('.' + badgeClass).forEach(function (badge) {
			badge.remove();
		});
	}

	function renderBadges() {
		removeBadges();

		document.querySelectorAll('section.section[id]').forEach(function (section) {
			if (!section.id) {
				return;
			}

			var badge = document.createElement('button');
			badge.type = 'button';
			badge.className = badgeClass;
			badge.textContent = '#' + section.id;
			badge.setAttribute('aria-label', 'Copy section id #' + section.id);
			badge.title = 'Double-click to copy';

			badge.addEventListener('dblclick', function (event) {
				event.preventDefault();
				event.stopPropagation();

				var value = '#' + section.id;
				copyText(value).then(function () {
					badge.classList.add(copiedClass);
					badge.textContent = 'Copied!';
					window.setTimeout(function () {
						badge.classList.remove(copiedClass);
						badge.textContent = value;
					}, 1200);
				}).catch(function () {});
			});

			section.insertBefore(badge, section.firstChild);
		});
	}

	function setActive(active) {
		document.body.classList.toggle('is-section-id-view-active', active);
		btn.setAttribute('aria-pressed', active ? 'true' : 'false');

		if (active) {
			renderBadges();
		} else {
			removeBadges();
		}

		try {
			sessionStorage.setItem(storageKey, active ? '1' : '0');
		} catch (e) {}
	}

	try {
		if (sessionStorage.getItem(storageKey) === '1') {
			setActive(true);
		}
	} catch (e) {}

	btn.addEventListener('click', function () {
		setActive(!document.body.classList.contains('is-section-id-view-active'));
	});
})();